<template>
    <div class="news">
        <!-- 新闻页 -->
        <div class="news-top"></div>

        <div class="inner inner-position">
            <div class="inner-title">
                <p>新闻资讯</p>
            </div>
            <!-- 搜索 -->
            <my-search class="search" @search="getSearch"></my-search>

            <!-- 轮播 -->
            <section-banner v-if="!isSearch" class="section" :data="companyBannerList.slice(0,4)"></section-banner>
            <div v-if="isSearch" class="section-bot"></div>

            <!-- 新闻列表 -->
            <news-card2 
                class="news-card" 
                :data="companyCard" 
                :search="queryForm.title"
            ></news-card2>

            <p class="news-bottom"> {{tipsText}}</p>
        </div>
    </div>
</template>

<script>
import minTitle from './components/min-title.vue';
import sectionBanner from './components/section-banner.vue';
import newsCard2 from './components/news-card2.vue';
import mySearch from './components/my-search.vue';

import appNode from '@js/app-node';
import CONFIG_PROJECT from '@config/project';

export default {
    head: {
        title: `新闻资讯·${CONFIG_PROJECT.title}`,
    },
    name: '',
    components: { minTitle, sectionBanner, newsCard2, mySearch },

    async asyncData(context) {
        let queryForm = {
            title: '',
            pageindex: 1,
            pagesize: 10,
            shbj: '9',
            fbbj: '1',
            sortorder: 'desc',
            sortname: 'fbdate',
        };

        let [majorlist] = await Promise.all([
            appNode.ssrReq.call(context, `${context.store.state.api.kjsUrl}/web/article/articlelist.json`, queryForm).then((data) => data),
        ]);
       
        let companyBannerList = majorlist.rows.slice(0, 4) || [];
        let companyCard = majorlist.rows.slice(4) || [];
        let total = majorlist.total;
        let end = majorlist.end;

        return {
            companyBannerList,
            companyCard,
            queryForm,
            total,
            end,
        };
    },

    data() {
        return {
            isSearch: false,
        };
    },
    mounted() {
    },
    computed: {
        tipsText(){
            if( this.end  < this.total){
                return '向下滚动加载更多新闻~'
            } else{
                return '~已经到底了~'
            }
        },
    },
    methods: {
        //搜索按钮，替换列表内容，隐藏轮播图
        getSearch(val) {
            if (val && val.length != 0) {
                this.isSearch = true;
            } else{
                this.isSearch = false;
            }
            this.queryForm.title = val;
            this.queryForm.pageindex = 1;
            this.getData('replace');
        },

        // 节流 计时器  防止出现 push 顺序错乱
        throttle(fn, time) {
            let timer = null;
            time = time || 1000;
            return function (...args) {
                if (timer) {
                    return;
                }
                const _this = this;
                timer = setTimeout(() => {
                    timer = null;
                }, time);
                fn.apply(_this, args);
            };
        },

        //滚动加载
        getData(type = 'add') {
            // 请求数据，拼接到 原数组上
            this.$get(`${this.$store.state.api.kjsUrl}/web/article/articlelist.json`, this.queryForm, (data) => {
                this.total = data.total;
                this.end = data.end;
                if (type == 'add') {
                    this.companyCard = [...this.companyCard, ...data.rows];
                } else {
                    this.companyCard = data.rows;
                }
            });
        },
        getDataScroll() {
            var newsBottom = document.querySelector('.news-bottom');
            var seeHeight = document.documentElement.clientHeight; //当前页面可见区域高度
            var toTop = newsBottom.getBoundingClientRect().top; //距离顶部高度

            if (toTop <= seeHeight) {
                if (this.end < this.total) {
                    this.queryForm.pageindex++; //页码+1 请求数据
                    this.getData();
                } 
            }
        },
    },

    beforeMount() {
        window.addEventListener('wheel', this.throttle(this.getDataScroll, 360));
    },
    beforeDestroy() {
        window.removeEventListener('wheel', this.getDataScroll);
    },
};
</script>


<style lang="scss" scoped>
.news {
    background-color: #fff;
    width: 100%;
    position: relative;
    .news-top {
        z-index: 0;
        width: 100%;
        height: 356px;
        background: url('/images/news/bg.png') no-repeat;
        background-size: 100% 100%;
        background-size: cover;
        .title {
            width: 1200px;
            height: 120px;
            margin: 0 auto;
            p {
                font-weight: 900;
                position: absolute;
                top: 100px;
            }
        }
    }
    .inner {
        width: 1200px;
        margin: 0 auto;
        z-index: 100;
        .inner-title p {
            font-size: 30px;
            font-weight: 600;
        }

        .search {
            margin: 30px auto 50px;
        }

        .section {
            margin-bottom: 20px;
            box-shadow: 10px 20px 20px rgba(0, 0, 0, 0.04);
        }
        .section-bot{
            height: 150px;
        }

        .news-card {
            min-height: 350px;
            box-shadow: none;
            overflow: visible;
        }
        .news-bottom {
            text-align: center;
            margin-top: -40px;
            padding-bottom: 20px;
            font-size: 16px;
            color: #131313;
        }
    }
    .inner-position {
        margin-top: -300px;
        // margin-bottom: 300px;
    }
    .bgc {
        background-color: #f8fafc;
        padding: 30px 0;
    }
}
</style>
